import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/** Triggers the callback only if the desired hash was entered */
export function useOnHashEnter(hash: string, callback: () => void) {
  const desiredHash = hash.startsWith('#') ? hash : `#${hash}`;
  const { hash: enteredHash } = useLocation();
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (enteredHash === desiredHash && typeof callbackRef.current === 'function') {
      callbackRef.current();
    }
  }, [enteredHash, desiredHash]);
}
